import React from "react";
import "./ManageUser.scss";
const ManageUser = () => {
  return <div className="ManageUser">ManageUser</div>;
};

export default ManageUser;
